<template>
  <div class="multiple-accounts">
    <p>
      <strong>{{ provider.name }}</strong> is already on your List. Would you like to tag an account already on your list as your
      <em>{{ servicesToString(folder.service_types) }}</em> provider, or add another account?

      <help-tip bottom>
        <strong>Add a new Account:</strong> If you receive a separate statement or bill for each account.<br />
        <strong>Use an Existing Account:</strong> If you get a single statement or bill.
      </help-tip>
    </p>
    <v-list class="mb-4 pt-0">
      <v-subheader>Use existing account:</v-subheader>
      <v-divider />
      <template v-for="f in folders">
        <v-list-tile
          :key="f.id"
          @click.prevent="updateFolder(f)"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ f.provider.name }}</v-list-tile-title>
            <v-list-tile-sub-title :title="servicesToString(f.service_types)">{{ servicesToString(f.service_types) }}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon color="primary">add_circle</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider />
      </template>
    </v-list>

    <v-btn
      @click.prevent="createFolder"
    >
      Or add a new account
    </v-btn>

  </div>
</template>

<script>
  import { foldersFor } from '@/helpers/providers'
  import HelpTip from '@/components/common/HelpTip'

  export default {
    data: function () {
      return {}
    },
    computed: {
      folders () {
        return foldersFor(this.provider)
      }
    },
    methods: {
      servicesToString (st) {
        return st.map((st) => {
          return st.name
        }).join(', ')
      },
      updateFolder (f) {
        let serviceTypes = f.service_types.concat(this.folder.service_types)
        let updatedFolder = Object.assign(f, {service_types: serviceTypes})
        this.$store.dispatch('folders/updateFolder', updatedFolder)
      },
      createFolder () {
        this.$store.dispatch('folders/createFolder', Object.assign(this.folder, { confirmed: true }))
      }
    },
    props: ['folder', 'provider'],
    components: {
      HelpTip
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/components/common/MultipleAccounts.vue